module.exports = __webpack_public_path__ + "static/03-170869f6a5a72b2c819bcde2130a1642.jpg";